import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=49c972b9&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=49c972b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c972b9",
  null
  
)

export default component.exports